import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs';
import { progressActions } from '../actions/progress.actions';
import { nextActions } from '../../content/next/actions/next.actions';

@Injectable({
    providedIn: 'root',
})
export class ProgressNextEffects {
    private readonly actions = inject(Actions);

    onMarkAsCompleteGetNextCourse$ = createEffect(() => {
        return this.actions.pipe(
            ofType(progressActions.markAsCompletedSuccess),
            map(() => nextActions.getNextContent()),
        );
    });
}
